module.exports = __webpack_public_path__ + "img/kh1.849161d1.png";